import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Auth } from '@aws-amplify/auth';

@Injectable({ providedIn: 'root' })
export class UserAdminGuard {
  constructor(private router: Router) {}

  async canActivateChild(
    _childRoute: ActivatedRouteSnapshot
  ): Promise<boolean | UrlTree> {
    return Auth.currentSession()
      .then((session) => {
        if (
          (
            session.getIdToken().payload['custom:impRoles']?.split(',') ??
            session.getIdToken().payload['cognito:groups']
          ).includes('USER_ADMIN')
        ) {
          return true;
        } else {
          return this.router.createUrlTree(['']);
        }
      })
      .catch(() => {
        return this.router.createUrlTree(['']);
      });
  }
}
